import { render, staticRenderFns } from "./confirm-addCollection.vue?vue&type=template&id=195dfd9d&scoped=true&"
import script from "./confirm-addCollection.vue?vue&type=script&lang=js&"
export * from "./confirm-addCollection.vue?vue&type=script&lang=js&"
import style0 from "./confirm-addCollection.vue?vue&type=style&index=0&id=195dfd9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195dfd9d",
  null
  
)

export default component.exports